import React from 'react';

const PlaceholderSignature = ({ canvasHeight, fontFamily }) => (
  <div
    className="pointer-events-none absolute inset-0 flex items-center justify-center text-neutral-400"
    style={{
      fontFamily: fontFamily || '"Allura", "Lucida Handwriting", "Brush Script MT", cursive',
      fontSize: Math.min(Math.round(canvasHeight * 0.24), 48)
    }}>
    Sign Here
  </div>
);

export default PlaceholderSignature;
